// UpdateNotificacionPage.tsx
import { useParams } from "react-router-dom";
import { LoaderComponent } from "@/shared/components/ui";
import { useFetchGetByIdNotificacion } from "@/shared/actions";
import SaveNotificacion from "../../components/save-notificacion/SaveNotificacion";

export default function UpdateNotificacionPage() {
  const { id } = useParams();

  const { data, isLoading, isRefetching } = useFetchGetByIdNotificacion(id!);

  if (isLoading || isRefetching) return <LoaderComponent />;

  return (
    <SaveNotificacion
      titulo="Actualizar Notificación"
      data={data?.data}
    />
  );
}
